import React, { ComponentType, FC } from 'react';
import dynamic from 'next/dynamic';
import { useMediaQueries } from 'src/common/providers/MediaQueryProvider';
import SimpleCarousel from './SimpleCarousel';
import { CarouselProps, CarouselItemProps } from './CarouselProps';
import getClassNames from '../../utils/getClassNames';

import styles from './Carousel.module.scss';

const EnhancedCarousel = dynamic(() => import('./EnhancedCarousel'), {
  ssr: false,
});

const SSREnhancedCarousel = dynamic(() => import('./EnhancedCarousel'), {
  ssr: true,
});

type CompoundCarousel = FC<CarouselProps> & {
  Item: FC<CarouselItemProps>;
};

/**
 * @deprecated Prefer `/dockyard/carousel/`
 * The only remaining importer of this component is `ListingCardImage`
 */
const Carousel: CompoundCarousel = ({
  loop = false,
  forceEnhanced = false,
  classNameModifier,
  children,
  slidesToScroll,
  preventEdgeScrolling,
  largeBreakpoint,
  withSSR = false,
}) => {
  const { hasPointer: hasPointerDevice } = useMediaQueries();
  const displayEnhancedCarousel = forceEnhanced || hasPointerDevice;

  let Component: ComponentType<CarouselProps> = SimpleCarousel;
  if (displayEnhancedCarousel && !withSSR) {
    Component = EnhancedCarousel;
  } else if (displayEnhancedCarousel && withSSR) {
    Component = SSREnhancedCarousel;
  }

  return (
    <Component
      loop={loop}
      classNameModifier={classNameModifier}
      slidesToScroll={slidesToScroll}
      preventEdgeScrolling={preventEdgeScrolling}
      largeBreakpoint={largeBreakpoint}
    >
      {children}
    </Component>
  );
};

Carousel.Item = ({ children, classNameModifier }) => (
  <li className={getClassNames(styles, 'item', classNameModifier)}>{children}</li>
);
export default Carousel;
